import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-idle-timeout',
    templateUrl: './idle-timeout.component.html',
    styleUrls: ['./idle-timeout.component.scss'],
    standalone: false
})
export class IdleTimeoutComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);

  @Output() idleResult = new EventEmitter<any>();

  @Input() message: string;

  ngOnInit(): void {
  }

  closeModal() {
    this.activeModal.close();
  }

  passResultToParent(result: boolean) {
    this.closeModal();
    this.idleResult.emit(result);
  }

}
